// extracted by mini-css-extract-plugin
module.exports = {"container":"testimonials_container__3PYfm"};